import React, { useEffect, useState } from "react";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import "yup-phone";
import {useNavigate, useParams} from "react-router";
import {Controller, useForm} from "react-hook-form";

// MUI
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";

// App imports
import ManagementFacetSelector from "./ManagementFacetSelector.jsx";
import Login from "../login/Login";
import RepoIconImg from "../RepoIconImg";

function RepositoryAddEditPage(props) {
    let params = useParams();
    console.log(params);

    const { id } = params;

    return ( <React.Fragment>
        <main>
            <div>
                {props.authString
                    ? <MainContent authString={props.authString} authRole={props.authRole} id={id}/>
                    : <Login setAuthString={props.setAuthString} />
                }
            </div>
        </main>
    </React.Fragment> );
}

const MainContent = (props) => {
    const [repository, setRepository] = useState({});
    const [DataisLoaded, setDataisLoaded] = useState(false);

    const navigate = useNavigate();

    const [open, setOpen] = React.useState(false);
    const [submittedData, setSubmittedData] = useState([]);

    const isEditMode = props.id;

    Yup.addMethod(Yup.MixedSchema, "oneOfSchemas", function (schemas) {
        return this.test(
            "one-of-schemas",
            "Enter valid url or e-mail address. URL must contain protocol (http:// or https://) and be a valid web address",
            (item) =>
                schemas.some((schema) => schema.isValidSync(item, { strict: true }))
        );
    });

    const publishableValidationSchema = Yup.object().shape({
        registering_name: Yup.string()
            .max(256, 'Name can not exceed 256 characters'),

        logo: Yup.mixed()
            .nullable()
            .test('fileSize', 'File size must be less than 5MB', (value) => {
                if (!value) return true;
                return value.size <= 5242880; // 5MB
            })
            .test('fileType', 'Only image files are allowed', (value) => {
                if (!value) return true;
                return ['image/jpeg', 'image/png', 'image/gif'].includes(value.type);
            }),
        registering_phone: Yup.string(),
        registering_email: Yup.string()
            .email('Email is invalid'),
        name: Yup.string()
            .required('Repository name is required')
            .max(256, 'Repository name can not exceed 256 characters'),
        nickname: Yup.string()
            .max(20, 'Repository short name can not exceed 20 characters'),
        description: Yup.string()
            .required('Description of repository is required'),
        url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address')
            .required('Repository URL is required'),
        help_url: Yup.mixed()
            .oneOfSchemas([
                Yup.string().url('Enter valid url or e-mail address. URL must contain protocol (http:// or https://) and be a valid web address'),
                Yup.string().email('Enter valid email')
            ])
            .required('Repository help URL or e-mail is required'),

        metadata_required: Yup.string()
            .required("A radio option is required"),
        metadata_required_description: Yup.string(),
        metadata_required_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        cost_to_submit: Yup.string()
            .required("A radio option is required"),
        costs_for_submit_description: Yup.string(),
        costs_for_submission_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        dua_or_cert_required: Yup.string()
            .required("A radio option is required"),
        dua_or_cert_required_description: Yup.string(),
        dua_or_cert_required_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        accepts_individual_data: Yup.string()
            .required("A radio option is required"),
        accepts_individual_description: Yup.string(),
        accepts_individual_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        requires_deidentified_data: Yup.string(),
        deidentification_level: Yup.string(),
        deidentification_description: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        private_sharing: Yup.string(),
        data_access_controlled: Yup.string()
            .required("A radio option is required"),
        data_access_controlled_description: Yup.string(),
        data_access_controlled_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        data_volume_limited: Yup.string()
            .required("A radio option is required"),
        data_volume_description: Yup.string(),
        data_volume_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        persistent_id_used: Yup.string()
            .required("A radio option is required"),
        persistent_id_description: Yup.string(),
        persistent_id_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        on_fairsharing: Yup.string()
            .required("A radio option is required"),
        fairsharing_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        generalist: Yup.string()
            .required("A radio option is required"),
        data_submission_reqs: Yup.string()
            .required("A radio option is required"),
        data_submission_reqs_description: Yup.string(),
        data_submission_reqs_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        data_standards: Yup.string(),
        data_standards_description: Yup.string(),
        data_standards_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),
        format_accepted_url: Yup.string().url('Enter valid url. Must contain protocol (http:// or https://) and be a valid web address'),

        // ===== FIXED: Non-circular validation for data_formats =====
    data_formats: Yup.array()
        .test('require-formats', 'You must select or enter at least one data format', function(value) {
            const { new_data_formats } = this.parent;
            if (!new_data_formats || new_data_formats === "") {
                return value && value.length > 0;
            }
            return true;
        }),
    new_data_formats: Yup.string(),

    // ===== FIXED: Non-circular validation for organisms =====
    organisms: Yup.array()
        .test('require-organisms', 'You must select or enter at least one organism', function(value) {
            const { new_organisms } = this.parent;
            if (!new_organisms || new_organisms === "") {
                return value && value.length > 0;
            }
            return true;
        }),
    new_organisms: Yup.string(),

    // ===== FIXED: Non-circular validation for data_types =====
    data_types: Yup.array()
        .test('require-data-types', 'You must select or enter at least one data type', function(value) {
            const { new_data_types } = this.parent;
            if (!new_data_types || new_data_types === "") {
                return value && value.length > 0;
            }
            return true;
        }),
    new_data_types: Yup.string(),

    // ===== FIXED: Non-circular validation for research_areas =====
    research_areas: Yup.array()
        .test('require-research-areas', 'You must select or enter at least one research area', function(value) {
            const { new_research_areas } = this.parent;
            if (!new_research_areas || new_research_areas === "") {
                return value && value.length > 0;
            }
            return true;
        }),
    new_research_areas: Yup.string(),

    // ===== FIXED: Non-circular validation for affiliations =====
    affiliations: Yup.array()
        .test('require-affiliations', 'You must select or enter at least one organization', function(value) {
            const { new_affiliations } = this.parent;
            if (!new_affiliations || new_affiliations === "") {
                return value && value.length > 0;
            }
            return true;
        }),
    new_affiliations: Yup.string(),




        status: Yup.mixed().oneOf(['Draft', 'In Review', 'Published', 'Ready for Publish']),
        change_log_comment: Yup.string().test("change-log",
            "Must enter justification of changes",
            (value, context) => {
                if (!isEditMode) {
                    return true;
                } else {
                    if (value === ""){
                        return false;
                    } else {
                        return true;
                    }
                }
            }
            )
    }, [["data_formats", "new_data_formats"], ["affiliations", "new_affiliations"], ["data_types", "new_data_types"], ["organisms", "new_organisms"], ["research_areas", "new_research_areas"]]);

    // functions to build form returned by useForm() hook
    const { register, handleSubmit, setValue, control, watch, formState: { errors } } = useForm({
        resolver: yupResolver(publishableValidationSchema)
    });

    // Watch all boolean fields
    const metadata_required = watch('metadata_required');
    const cost_to_submit = watch('cost_to_submit');
    const dua_or_cert_required = watch('dua_or_cert_required');
    const accepts_individual_data = watch('accepts_individual_data');
    const data_access_controlled = watch('data_access_controlled');
    const data_volume_limited = watch('data_volume_limited');
    const persistent_id_used = watch('persistent_id_used');
    const on_fairsharing = watch('on_fairsharing');
    const data_submission_reqs = watch('data_submission_reqs');
    const data_standards = watch('data_standards');
    const requires_deidentified_data = watch('requires_deidentified_data');

    // Helper function to check if field should be shown
    const shouldShowField = (fieldName) => {
        const watchedValue = watch(fieldName);
        const repositoryValue = repository[fieldName];
        const currentValue = watchedValue !== undefined ? watchedValue : repositoryValue;
        return currentValue === "true" || currentValue === true;
    };

    // Define boolean fields and their related detail/URL fields
    const booleanFieldsWithRelated = {
        'metadata_required': ['metadata_required_description', 'metadata_required_url'],
        'cost_to_submit': ['costs_for_submit_description', 'costs_for_submission_url'],
        'dua_or_cert_required': ['dua_or_cert_required_description', 'dua_or_cert_required_url'],
        'accepts_individual_data': ['accepts_individual_description', 'accepts_individual_url'],
        'data_access_controlled': ['data_access_controlled_description', 'data_access_controlled_url'],
        'data_volume_limited': ['data_volume_description', 'data_volume_url'],
        'persistent_id_used': ['persistent_id_description', 'persistent_id_url'],
        'on_fairsharing': ['fairsharing_url'],
        'data_submission_reqs': ['data_submission_reqs_description', 'data_submission_reqs_url'],
        'data_standards': ['data_standards_description', 'data_standards_url'],
        'requires_deidentified_data': ['deidentification_level', 'deidentification_description']
    };

    const processData = (data) => {
        let processedData = {};

        Object.keys(data).forEach((key) => {
            // Skip completely empty values for non-related fields
            if (data[key] === null || data[key] === undefined || data[key] === 'null' || data[key] === "") {
                // Check if this is a related field that should be explicitly cleared
                let isRelatedField = false;
                for (const [booleanField, relatedFields] of Object.entries(booleanFieldsWithRelated)) {
                    if (relatedFields.includes(key)) {
                        isRelatedField = true;
                        // If parent field is not "true", explicitly set to empty string
                        if (data[booleanField] !== "true") {
                            processedData[key] = "";
                            console.log(`Setting ${key} to empty string because ${booleanField} is not "true"`);
                        }
                        break;
                    }
                }

                // If not a related field, skip it
                if (!isRelatedField) {
                    return;
                }
            } else {
                // Field has a value, check if it should be included
                let shouldInclude = true;
                for (const [booleanField, relatedFields] of Object.entries(booleanFieldsWithRelated)) {
                    if (relatedFields.includes(key)) {
                        // Only include if parent field is "true"
                        if (data[booleanField] !== "true") {
                            shouldInclude = false;
                            // Explicitly set to empty string to clear in database
                            processedData[key] = "";
                            console.log(`Clearing ${key} (was: "${data[key]}") because ${booleanField} is not "true"`);
                            break;
                        }
                    }
                }

                if (shouldInclude) {
                    processedData[key] = data[key];
                }
            }
        });

    console.log('Processed Data:', processedData);
    return processedData;
}

    const onSubmit = (data) => {
        console.log("✅ onSubmit called!");
        console.log("Form data:", data);
        console.log("Repository status:", repository.status);
        console.log("Publish status:", publish_status(repository.status));

        if(publish_status(repository.status) === 0 || publish_status(repository.status) === 2) {
            setSubmittedData(data);
            handlePublishOpen();
        } else {
            return isEditMode
                ? updateRepository(props.id, data, props.authString)
                : createRepository(data, props.authString);
        }
    }

    function createRepository(data, authString) {
    const requestUrl = process.env.REACT_APP_API_BASE_URL + 'admin/repositories/add';

    let processedData = processData(data);

    const formData = new FormData();
    const { logo, ...jsonData } = processedData;
    formData.append('json', JSON.stringify(jsonData));

    if (logo instanceof File) {
        formData.append('logo', logo);
    }

    return fetch(requestUrl, {
        method: 'POST',
        headers: new Headers({
            'Authorization': `Basic ${authString}`
        }),
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        let repo = data;
        console.log(data);
        let id = repo.id;
        console.log(id);

        // Clear excluded fields from form state after successful submission
        clearExcludedFields();

        navigate('/repositories/management/preview/' + id);
    });
}

    function updateRepository(id, data, authString) {
        const requestUrl = process.env.REACT_APP_API_BASE_URL + 'admin/repositories/' + id + '/update';

        let processedData = processData(data);

        // Non-publishers always move the repo back to "In Review" when saving edits
        if (props.authRole === 'non_publisher') {
            processedData.status = 'In Review';
        }

        const formData = new FormData();
        const { logo, ...jsonData } = processedData;

        formData.append('json', JSON.stringify(jsonData));

        if (logo instanceof File) {
            formData.append('logo', logo);
        }

        return fetch(requestUrl, {
            method: 'POST',
            headers: new Headers({
                'Authorization': `Basic ${authString}`
            }),
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            // Clear excluded fields from form state after successful submission
            clearExcludedFields();

            navigate('/repositories/management/preview/' + id);
        });
    }

    // Add this helper function to clear excluded fields
    const clearExcludedFields = () => {
        // Get current form values
        const currentValues = watch();

        // Check each boolean field and clear related fields if not "true"
        Object.entries(booleanFieldsWithRelated).forEach(([booleanField, relatedFields]) => {
            if (currentValues[booleanField] !== "true") {
                relatedFields.forEach(relatedField => {
                    setValue(relatedField, "");
                    console.log(`Cleared ${relatedField} because ${booleanField} is not "true"`);
                });
            }
        });
    };

    const handleCsvUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (e) => {
        const text = e.target.result;
        const lines = text
            .split(/\r?\n/)
            .map(line => line.trim())
            .filter(line => line.length > 0);

        const multiSelectFields = {
            "affiliations": "branches",
            "data_types": "data_types",
            "organisms": "organisms",
            "research_areas": "research_areas",
            "data_formats": "data_formats_unfiltered"
        };

        const backendData = {};
        for (const [field, endpoint] of Object.entries(multiSelectFields)) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}${endpoint}`);
                const data = await response.json();
                backendData[field] = data;
                console.log(`✓ Fetched ${data.length} items for ${field}:`, data[0]); // Log first item to see structure
            } catch (error) {
                console.error(`Error fetching ${field}:`, error);
                backendData[field] = [];
            }
        }

        lines.forEach(line => {
            const firstCommaIndex = line.indexOf(",");
            if (firstCommaIndex === -1) return;

            const rawKey = line.substring(0, firstCommaIndex).trim();
            let value = line.substring(firstCommaIndex + 1).trim();

            if (!rawKey || value === "") return;

            const key = rawKey.toLowerCase();

            if (Object.keys(multiSelectFields).includes(key)) {
                let csvValues = value
                    .split(';')
                    .map(v => v.trim())
                    .filter(v => v.length > 0);

                if (csvValues.length > 0) {
                    const matchedItems = [];

                    csvValues.forEach(csvValue => {
                        const match = backendData[key].find(item =>
                            item.name.toLowerCase().trim() === csvValue.toLowerCase().trim()
                        );

                        if (match) {
                            // Use the ENTIRE backend object, not just selected fields
                            matchedItems.push(match);
                            console.log(`✓ Matched ${key}: "${csvValue}" -> Full object:`, match);
                        } else {
                            console.warn(`⚠ No match found for ${key}: "${csvValue}"`);
                        }
                    });

                    if (matchedItems.length > 0) {
                        console.log(`Setting ${key} with ${matchedItems.length} items:`, matchedItems);
                        // Use shouldValidate and shouldDirty to ensure the form updates
                        setValue(key, matchedItems, {
                            shouldValidate: true,
                            shouldDirty: true,
                            shouldTouch: true
                        });

                        // Force a re-render by triggering the watch
                        console.log(`${key} now has value:`, watch(key));
                    }

                    const unmatchedValues = csvValues.filter(csvValue =>
                        !backendData[key].some(item =>
                            item.name.toLowerCase().trim() === csvValue.toLowerCase().trim()
                        )
                    );

                    if (unmatchedValues.length > 0) {
                        const newFieldKey = `new_${key}`;
                        setValue(newFieldKey, unmatchedValues.join(', '));
                        console.log(`✓ Added ${unmatchedValues.length} unmatched ${key} to ${newFieldKey}`);
                    }
                }
                return;
            }

            const booleanFields = [
                "metadata_required",
                "cost_to_submit",
                "dua_or_cert_required",
                "accepts_individual_data",
                "requires_deidentified_data",
                "data_access_controlled",
                "data_volume_limited",
                "persistent_id_used",
                "on_fairsharing",
                "generalist",
                "data_submission_reqs",
                "data_standards",
                "private_sharing",
                "requres_deidentified_data"
            ];

            if (booleanFields.includes(key)) {
                const normalized = value.toLowerCase();
                if (normalized === "true") {
                    setValue(key, "true");
                } else if (normalized === "false") {
                    setValue(key, "false");
                } else {
                    setValue(key, "null");
                }
                return;
            }

            setValue(key, value);
        });

        console.log("✓ CSV loaded into form - ready to edit and submit");

        // Debug output
        setTimeout(() => {
            console.log("=== Multi-select field values after CSV load ===");
            console.log("affiliations:", watch("affiliations"));
            console.log("data_types:", watch("data_types"));
            console.log("organisms:", watch("organisms"));
            console.log("research_areas:", watch("research_areas"));
            console.log("data_formats:", watch("data_formats"));
        }, 500);
    };

    reader.readAsText(file);
    event.target.value = "";
};

    const sanitizeCsvValue = (value) => {
        return String(value).replace(/\r?\n|\r/g, " ").trim();
    };

    const formatCsvFieldValue = (value) => {
        if (value === null || value === undefined) {
            return "";
        }

        if (Array.isArray(value)) {
            return value
                .map((item) => {
                    if (typeof item === "string") {
                        return item.trim();
                    }

                    if (item && typeof item === "object" && item.name) {
                        return String(item.name).trim();
                    }

                    return String(item).trim();
                })
                .filter(Boolean)
                .join("; ");
        }

        if (typeof value === "boolean") {
            return value ? "true" : "false";
        }

        if (value instanceof File) {
            return "";
        }

        if (typeof value === "object") {
            return "";
        }

        return sanitizeCsvValue(value);
    };

    const handleCsvDownload = () => {
        const currentValues = watch();

        if (!isEditMode) {
            const templateFields = [
                { key: "accepts_individual_data", defaultValue: "FALSE" },
                { key: "accepts_individual_description", defaultValue: "" },
                { key: "accepts_individual_url", defaultValue: "" },
                { key: "affiliations", defaultValue: "" },
                { key: "change_log", defaultValue: "" },
                { key: "cost_to_submit", defaultValue: "FALSE" },
                { key: "data_access_controlled", defaultValue: "FALSE" },
                { key: "data_access_controlled_description", defaultValue: "" },
                { key: "data_access_controlled_url", defaultValue: "" },
                { key: "data_formats", defaultValue: "" },
                { key: "data_standards", defaultValue: "" },
                { key: "data_submission_reqs", defaultValue: "FALSE" },
                { key: "data_submission_reqs_description", defaultValue: "" },
                { key: "data_submission_reqs_url", defaultValue: "" },
                { key: "data_types", defaultValue: "" },
                { key: "data_volume_limited", defaultValue: "FALSE" },
                { key: "deidentification_description", defaultValue: "" },
                { key: "deidentification_level", defaultValue: "" },
                { key: "description", defaultValue: "" },
                { key: "dua_or_cert_required", defaultValue: "FALSE" },
                { key: "dua_or_cert_required_description", defaultValue: "" },
                { key: "dua_or_cert_required_url", defaultValue: "" },
                { key: "fairsharing_url", defaultValue: "" },
                { key: "generalist", defaultValue: "FALSE" },
                { key: "help_url", defaultValue: "" },
                { key: "metadata_required", defaultValue: "FALSE" },
                { key: "metadata_required_description", defaultValue: "" },
                { key: "metadata_required_url", defaultValue: "" },
                { key: "name", defaultValue: "" },
                { key: "nickname", defaultValue: "" },
                { key: "on_fairsharing", defaultValue: "FALSE" },
                { key: "organisms", defaultValue: "" },
                { key: "persistent_id_description", defaultValue: "" },
                { key: "persistent_id_used", defaultValue: "FALSE" },
                { key: "private_sharing", defaultValue: "FALSE" },
                { key: "registering_email", defaultValue: "" },
                { key: "registering_name", defaultValue: "" },
                { key: "registering_phone", defaultValue: "" },
                { key: "requires_deidentified_data", defaultValue: "FALSE" },
                { key: "research_areas", defaultValue: "" },
                { key: "status", defaultValue: "" },
                { key: "url", defaultValue: "" }
            ];

            const hasUserValue = (value) => {
                if (value === undefined || value === null) {
                    return false;
                }

                if (typeof value === "string") {
                    return value.trim() !== "";
                }

                if (Array.isArray(value)) {
                    return value.length > 0;
                }

                return true;
            };

            const normalizeTemplateValue = (value) => {
                const normalized = formatCsvFieldValue(value);

                if (typeof normalized === "string") {
                    const lower = normalized.toLowerCase();
                    if (lower === "true") {
                        return "TRUE";
                    }
                    if (lower === "false") {
                        return "FALSE";
                    }
                    if (lower === "null") {
                        return "NULL";
                    }
                }

                return normalized;
            };

            const templateLines = templateFields.map(({ key, defaultValue }) => {
                const userValue = currentValues[key];
                const finalValue = hasUserValue(userValue)
                    ? normalizeTemplateValue(userValue)
                    : defaultValue;

                return `${key}, ${finalValue}`;
            });

            const templateBlob = new Blob([templateLines.join("\n")], { type: "text/csv;charset=utf-8;" });
            const templateUrl = window.URL.createObjectURL(templateBlob);
            const templateLink = document.createElement("a");

            templateLink.href = templateUrl;
            templateLink.setAttribute("download", "repository_template.csv");

            document.body.appendChild(templateLink);
            templateLink.click();
            document.body.removeChild(templateLink);

            window.URL.revokeObjectURL(templateUrl);
            return;
        }

        const exportSource = isEditMode ? { ...repository, ...currentValues } : currentValues;

        const excludedFields = new Set([
            "id",
            "logo",
            "csvFile",
            "created",
            "updated",
            "created_at",
            "updated_at",
            "published",
            "last_edited"
        ]);

        const lines = Object.keys(exportSource)
            .filter((key) => !excludedFields.has(key))
            .map((key) => {
                const formattedValue = formatCsvFieldValue(exportSource[key]);
                if (formattedValue === "") {
                    return null;
                }

                return `${key},${sanitizeCsvValue(formattedValue)}`;
            })
            .filter(Boolean);

        if (!lines.length) {
            alert("No repository details available to export.");
            return;
        }

        const rawName = sanitizeCsvValue(currentValues.name || repository.name || "repository");
        const fileNameBase = rawName
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "_")
            .replace(/^_+|_+$/g, "") || "repository";

        const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = downloadUrl;
        link.setAttribute("download", `${fileNameBase}_details.csv`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(downloadUrl);
    };



    const handlePublishOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    }

    function handlePublishEdits() {
        setOpen(false);
        return updateRepository(props.id, submittedData, props.authString)
    }

    useEffect( () => {
        if (!props.authString) {
            console.log("not logged in");
            navigate("/login");
        } else if (isEditMode) {
            var requestUrl = process.env.REACT_APP_API_BASE_URL + "repositories/" + props.id;

            fetch(requestUrl)
                .then(response => response.json())
                .then((responseJson) => {
                    setDataisLoaded(true);
                    setRepository(responseJson);

                    const fields = publishableValidationSchema.describe().fields;
                    Object.keys(fields).forEach((field, idx) =>
                    {
                        if(Array.isArray(responseJson[field])) {
                            setValue(field, responseJson[field]);
                        } else if(responseJson[field] !== undefined && responseJson[field] !== null)
                            setValue(field, responseJson[field]);
                    });
                })
        }
    }, [DataisLoaded, props.authString]);

    useEffect(() => {console.log(errors)}, [errors]);

    if (!isEditMode || DataisLoaded) {
        return (
        <React.Fragment>
            <Box className='repository-management'>
                <div className='repository-management-title'>
                    <span style={{ marginLeft: '40px' }}>Data Repository Registration</span>
                    <Typography variant='body2' style={{ marginLeft: '40px' }}>Please fill in the fields below to register your data repository with the Data Repository Finder. Unless otherwise noted, all information entered will be publicly displayed on the repository details page for this repository. You will be able to preview the details page before submitting the repository for review.</Typography>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} style={{ margin: '25px 50px', paddingBottom: '80px' }}>
                    <h3>Data Repository Information</h3>

                   <Grid container spacing={3} sx={{ marginBottom: 0 }}>

                     <Grid xs={12} md={6}>
                        <div className="form-group">
                            <label>Please upload a Logo</label>
                            <div className="form-error" role="alert">{errors.logo?.message}</div>
                            <Controller
                                name="logo"
                                control={control}
                                defaultValue={null}
                                render={({field: {onChange, value}}) => (
                                    <>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                            id="logo-file-input"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    onChange(file);
                                                }
                                            }}
                                        />
                                        <label
                                            htmlFor="logo-file-input"
                                            style={{
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '12px'
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 50,
                                                    height: 50,
                                                    border: '2px dashed #ccc',
                                                    borderRadius: '4px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    overflow: 'hidden',
                                                    backgroundColor: '#f5f5f5',
                                                    flexShrink: 0,
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': {
                                                        borderColor: '#1976d2',
                                                        backgroundColor: '#e3f2fd',
                                                    }
                                                }}
                                            >
                                                {value ? (
                                                    <img
                                                        src={URL.createObjectURL(value)}
                                                        alt="Logo preview"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                ) : isEditMode && repository.name ? (

                                                   <RepoIconImg altText={repository.name + " logo"} imageUri={'repo_logos/' + repository.name + '.png'} />
                                                ) : (
                                                    <Typography variant="caption" color="textSecondary" sx={{ fontSize: '10px' }}>
                                                        +
                                                    </Typography>
                                                )}
                                            </Box>
                                            <Typography variant="body2" color="textSecondary">
                                                {value ? value.name : 'Click to upload logo (Max 5MB)'}
                                            </Typography>
                                        </label>
                                    </>
                                )}
                            />
                        </div>
                    </Grid>

                    <Grid xs={12} md={6}>
                        <div className="form-group">
                            <label>Load repository from CSV</label>
                            <br />
                            <Controller
                                name="csvFile"
                                control={control}
                                defaultValue={null}
                                render={({field: {onChange, value}}) => (
                                    <>
                                        <input
                                            type="file"
                                            accept=".csv"
                                            style={{ display: 'none' }}
                                            id="csv-file-input"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    onChange(file);
                                                    handleCsvUpload(e);
                                                }
                                            }}
                                        />
                                        <label htmlFor="csv-file-input" style={{ width: '100%' }}>
                                            <TextField
                                                fullWidth
                                                className="form-field"
                                                value={value ? value.name : ''}
                                                placeholder="No file chosen"
                                                InputProps={{ readOnly: true }}
                                                onClick={() => document.getElementById('csv-file-input').click()}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </label>

                                        <Button
                                            size="small"
                                            variant="outlined"
                                            style={{ marginTop: '10px' }}
                                            onClick={handleCsvDownload}
                                        >
                                            {isEditMode ? 'Download current details as CSV' : 'Download repository CSV template'}
                                        </Button>
                                    </>
                                )}
                            />
                        </div>
                    </Grid>
                </Grid>


                <div className="form-group">
                        <label>Repository Name <span className='red-icon'>*</span></label>
                        <div className="form-error" role="alert">{errors.name?.message}</div>
                        <br />
                        <Controller
                            name="name"
                            control={control}
                            rules={publishableValidationSchema.name}
                            defaultValue=""
                            render={({field}) => (
                                <TextField fullWidth
                                           label="Repository Name"
                                           className="form-field"
                                           {...field} />
                            )} />
                    </div>

                    <div className="form-group">
                        <label>Repository Short Name</label>
                        <div className="form-error" role="alert">{errors.nickname?.message}</div>
                        <br />
                        <Controller
                            name="nickname"
                            control={control}
                            rules={publishableValidationSchema.nickname}
                            defaultValue=""
                            render={({field}) => (
                                <TextField fullWidth
                                           label="Repository Short Name"
                                           className="form-field"
                                           {...field} />
                            )} />
                    </div>

                    <div className="form-collection">
                        <div className="form-group">
                            <label>Select the organization(s) that house and maintain the repository.
                                <span className='red-icon'>*</span>
                            </label>
                            <div className="form-error" role="alert">{errors.affiliations?.message}</div>
                            <Controller
                                name="affiliations"
                                control={control}
                                rules={publishableValidationSchema.affiliations}
                                defaultValue={[]}
                                render={({field: {onChange, value}}) => (
                                    <ManagementFacetSelector
                                            className="form-field"
                                            onSelect={(e, data) => { console.log('data'); console.log(data); onChange(data) }}
                                            defaultValue={repository['affiliations']}
                                            {...register('affiliations')}
                                            value={value}
                                            id={'affiliations'}
                                            facet='branches' />
                                    )} />
                        </div>

                        <div className="form-group">
                            <label>If your organization isn't in the list above enter it here. </label>
                            <div className="form-error" role="alert">{errors.new_affiliations?.message}</div>
                            <br />
                            <Controller
                                name="new_affiliations"
                                control={control}
                                rules={publishableValidationSchema.new_affiliations}
                                defaultValue=""
                                render={({field}) => (
                                    <TextField fullWidth
                                               label=""
                                               className="form-field"
                                               {...field} />
                                )} />
                        </div>
                    </div>
                    <br/>

                    <div className="form-group">
                        <label>Repository Description <span className='red-icon'>*</span></label>
                        <div className="form-error" role="alert">{errors.description?.message}</div>
                        <br />
                        <Controller
                            name="description"
                            control={control}
                            rules={publishableValidationSchema.description}
                            defaultValue=""
                            render={({field}) => (
                                <TextField fullWidth
                                            multiline
                                            minRows={3}
                                            label="Provide a 1-2 sentence overview of what the site is and what it is for."
                                            className="form-field"
                                            {...field} />
                            )} />
                    </div>

                    <div className="form-group">
                        <label>Repository Landing Page URL (Must start with http:// or https://)<span className='red-icon'>*</span></label>
                        <div className="form-error" role="alert">{errors.url?.message}</div>
                        <br />
                        <Controller
                            name="url"
                            control={control}
                            rules={publishableValidationSchema.url}
                            defaultValue=""
                            render={({field}) => (
                                <TextField fullWidth
                                            label="Repository URL"
                                            className="form-field"
                                            {...field} />
                            )} />
                    </div>

                    <div className="form-group">
                        <label>Repository Help Url or E-mail (Url must start with http:// or https://)<span className='red-icon'>*</span></label>
                        <div className="form-error" role="alert">{errors.help_url?.message}</div>
                        <br />
                        <Controller
                            name="help_url"
                            control={control}
                            rules={publishableValidationSchema.help_url}
                            defaultValue=""
                            render={({field}) => (
                                <TextField fullWidth
                                            label="Help URL"
                                            className="form-field"
                                            {...field} />
                            )} />
                    </div>

                    <Grid container rowSpacing={3} columnSpacing={3}>
                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Does your repository require Controlled Access?</label>
                                    <div className="form-error" role="alert">{errors.data_access_controlled?.message}</div>
                                    <br />
                                    <Controller
                                        name="data_access_controlled"
                                        control={control}
                                        rules={publishableValidationSchema.data_access_controlled}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row className="form-field"{...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unknown" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('data_access_controlled') && (
                                    <>
                                        <div className="form-group">
                                            <label>Briefly describe information about controlled access for this repository.</label>
                                            <div className="form-error"
                                                role="alert">{errors.data_access_controlled_description?.message}</div>
                                            <br />
                                            <Controller
                                                name="data_access_controlled_description"
                                                control={control}
                                                rules={publishableValidationSchema.data_access_controlled_description}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>

                                        <div className="form-group">
                                            <label>Provide a public URL link to any controlled access information for this
                                                repository. (Must start with http:// or https://)</label>
                                            <div className="form-error"
                                                role="alert">{errors.data_access_controlled_url?.message}</div>
                                            <br />
                                            <Controller
                                                name="data_access_controlled_url"
                                                control={control}
                                                rules={publishableValidationSchema.data_access_controlled_url}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Does your repository require metadata?</label>
                                    <div className="form-error" role="alert">{errors.metadata_required?.message}</div>
                                    <br />
                                    <Controller
                                        name="metadata_required"
                                        control={control}
                                        rules={publishableValidationSchema.metadata_required}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unknown" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('metadata_required') && (
                                    <>
                                        <div className="form-group">
                                            <label>Briefly describe your metadata recommendations and requirements.</label>
                                            <div className="form-error"
                                                role="alert">{errors.metadata_required_description?.message}
                                            </div>
                                            <br />
                                            <Controller
                                                name="metadata_required_description"
                                                control={control}
                                                rules={publishableValidationSchema.metadata_required_description}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>

                                        <div className="form-group">
                                            <label>Provide a public URL link to any metadata requirements. (Must start with http:// or https://)</label>
                                            <div className="form-error" role="alert">{errors.metadata_required_url?.message}</div>
                                            <br />
                                            <Controller
                                                name="metadata_required_url"
                                                control={control}
                                                rules={publishableValidationSchema.metadata_required_url}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Does your repository have any data volume limitations?</label>
                                    <div className="form-error" role="alert">{errors.data_volume_limited?.message}</div>
                                    <br />
                                    <Controller
                                        name="data_volume_limited"
                                        control={control}
                                        rules={publishableValidationSchema.data_volume_limited}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="Unknown" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unknown" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('data_volume_limited') && (
                                    <>
                                        <div className="form-group">
                                            <label>Briefly describe any data volume limitations for this repository.</label>
                                            <div className="form-error"
                                                role="alert">{errors.data_volume_description?.message}</div>
                                            <br />
                                            <Controller
                                                name="data_volume_description"
                                                control={control}
                                                rules={publishableValidationSchema.data_volume_description}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>

                                        <div className="form-group">
                                            <label>Provide a public URL link to any data volume limitation information. (Must start with http:// or https://)</label>
                                            <div className="form-error" role="alert">{errors.data_volume_url?.message}</div>
                                            <br />
                                            <Controller
                                                name="data_volume_url"
                                                control={control}
                                                rules={publishableValidationSchema.data_volume_url}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Does your repository accept individual-level data?</label>
                                    <div className="form-error" role="alert">{errors.accepts_individual_data?.message}</div>
                                    <br />
                                    <Controller
                                        name="accepts_individual_data"
                                        control={control}
                                        rules={publishableValidationSchema.accepts_individual_data}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="Unknown" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unknown" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('accepts_individual_data') && (
                                    <>
                                        <div className="form-group">
                                            <label>Briefly describe whether this repository accepts individual-level data.</label>
                                            <div className="form-error"
                                                role="alert">{errors.accepts_individual_description?.message}</div>
                                            <br />
                                            <Controller
                                                name="accepts_individual_description"
                                                control={control}
                                                rules={publishableValidationSchema.accepts_individual_description}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>

                                        <div className="form-group">
                                            <label>Provide a public URL link to any individual-level data information. (Must start with http:// or https://)</label>
                                            <div className="form-error" role="alert">{errors.accepts_individual_url?.message}</div>
                                            <br />
                                            <Controller
                                                name="accepts_individual_url"
                                                control={control}
                                                rules={publishableValidationSchema.accepts_individual_url}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Does your repository have standards for data submitted?</label>
                                    <div className="form-error" role="alert">{errors.data_standards?.message}</div>
                                    <br />
                                    <Controller
                                        name="data_standards"
                                        control={control}
                                        rules={publishableValidationSchema.data_standards}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="Unknown" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unknown" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('data_standards') && (
                                    <>
                                        <div className="form-group">
                                            <label>Briefly describe information about the standards for data submitted.</label>
                                            <div className="form-error" role="alert">{errors.data_standards_description?.message}</div>
                                            <br />
                                            <Controller
                                                name="data_standards_description"
                                                control={control}
                                                rules={publishableValidationSchema.data_standards_description}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>

                                        <div className="form-group">
                                            <label>Provide a public URL link to any information relevant to standards for submitted data. (Must start with http:// or https://)</label>
                                            <div className="form-error" role="alert">{errors.data_standards_url?.message}</div>
                                            <br />
                                            <Controller
                                                name="data_standards_url"
                                                control={control}
                                                rules={publishableValidationSchema.data_standards_url}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Please select one of the following to best describe the de-identification requirements for data submitters.</label>
                                    <div className="form-error" role="alert">{errors.requires_deidentified_data?.message}</div>
                                    <br />
                                    <Controller
                                        name="requires_deidentified_data"
                                        control={control}
                                        rules={publishableValidationSchema.requires_deidentified_data}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="Unknown" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unknown" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('requires_deidentified_data') && (
                                    <>
                                        <div className="form-group">
                                            <label>Briefly describe your repository's de-identification requirements. (HIPAA Safe Harbor, Common Rule, etc)</label>
                                            <div className="form-error" role="alert">{errors.deidentification_level?.message}</div>
                                            <br />
                                            <Controller
                                                name="deidentification_level"
                                                control={control}
                                                rules={publishableValidationSchema.deidentification_level}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>

                                        <div className="form-group">
                                            <label>Provide a public URL link to any information about de-identification. (Must start with http:// or https://)</label>
                                            <div className="form-error" role="alert">{errors.deidentification_description?.message}</div>
                                            <br />
                                            <Controller
                                                name="deidentification_description"
                                                control={control}
                                                rules={publishableValidationSchema.deidentification_description}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Does your repository use a persistent id for data sets?</label>
                                    <div className="form-error" role="alert">{errors.persistent_id_used?.message}</div>
                                    <br />
                                    <Controller
                                        name="persistent_id_used"
                                        control={control}
                                        rules={publishableValidationSchema.persistent_id_used}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="Unknown" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unknown" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('persistent_id_used') && (
                                    <>
                                        <div className="form-group">
                                            <label>Briefly describe whether this repository uses a persistent id for data
                                                sets.</label>
                                            <div className="form-error"
                                                role="alert">{errors.persistent_id_description?.message}</div>
                                            <br />
                                            <Controller
                                                name="persistent_id_description"
                                                control={control}
                                                rules={publishableValidationSchema.persistent_id_description}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>

                                        <div className="form-group">
                                            <label>Provide a public URL link to any information about persistent ids. (Must start with http:// or https://)</label>
                                            <div className="form-error" role="alert">{errors.persistent_id_url?.message}</div>
                                            <br />
                                            <Controller
                                                name="persistent_id_url"
                                                control={control}
                                                rules={publishableValidationSchema.persistent_id_url}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Does your repository require a fee to submit data?</label>
                                    <div className="form-error" role="alert">{errors.cost_to_submit?.message}</div>
                                    <br />
                                    <Controller
                                        name="cost_to_submit"
                                        control={control}
                                        rules={publishableValidationSchema.cost_to_submit}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="Unknown" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unknown" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('cost_to_submit') && (
                                    <>
                                        <div className="form-group">
                                            <label>Briefly describe information about costs to submit data.</label>
                                            <div className="form-error"
                                                role="alert">{errors.costs_for_submit_description?.message}</div>
                                            <br />
                                            <Controller
                                                name="costs_for_submit_description"
                                                control={control}
                                                rules={publishableValidationSchema.costs_for_submit_description}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Provide a public URL link to any submission costs information. (Must start with http:// or https://)</label>
                                            <div className="form-error" role="alert">{errors.costs_for_submission_url?.message}</div>
                                            <br />
                                            <Controller
                                                name="costs_for_submission_url"
                                                control={control}
                                                rules={publishableValidationSchema.costs_for_submission_url}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Does your repository require Data Submission Agreement/
                                        Institutional Certification Required for Data Submission?</label>
                                    <div className="form-error" role="alert">{errors.dua_or_cert_required?.message}</div>
                                    <br />
                                    <Controller
                                        name="dua_or_cert_required"
                                        control={control}
                                        rules={publishableValidationSchema.dua_or_cert_required}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="Unknown" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unknown" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('dua_or_cert_required') && (
                                    <>
                                        <div className="form-group">
                                            <label>Briefly describe information about Data Submission Agreement/
                                                Institutional Certification requirements.</label>
                                            <div className="form-error"
                                                role="alert">{errors.dua_or_cert_required_description?.message}</div>
                                            <br />
                                            <Controller
                                                name="dua_or_cert_required_description"
                                                control={control}
                                                rules={publishableValidationSchema.dua_or_cert_required_description}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>

                                        <div className="form-group">
                                            <label>Provide a public URL link to any information about Data Submission Agreement/
                                                Institutional Certification requirements. (Must start with http:// or https://)</label>
                                            <div className="form-error"
                                                role="alert">{errors.dua_or_cert_required_url?.message}</div>
                                            <br />
                                            <Controller
                                                name="dua_or_cert_required_url"
                                                control={control}
                                                rules={publishableValidationSchema.dua_or_cert_required_url}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Does your repository have any other data submission requirements?</label>
                                    <div className="form-error" role="alert">{errors.data_submission_reqs?.message}</div>
                                    <br />
                                    <Controller
                                        name="data_submission_reqs"
                                        control={control}
                                        rules={publishableValidationSchema.data_submission_reqs}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="Unknown" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unknown" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('data_submission_reqs') && (
                                    <>
                                        <div className="form-group">
                                            <label>Briefly describe information about other data submission requirements.</label>
                                            <div className="form-error"
                                                role="alert">{errors.data_submission_reqs_description?.message}</div>
                                            <br />
                                            <Controller
                                                name="data_submission_reqs_description"
                                                control={control}
                                                rules={publishableValidationSchema.data_submission_reqs_description}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>

                                        <div className="form-group">
                                            <label>Provide a public URL link to any information about other data submission
                                                requirements. (Must start with http:// or https://)</label>
                                            <div className="form-error"
                                                role="alert">{errors.data_submission_reqs_url?.message}</div>
                                            <br />
                                            <Controller
                                                name="data_submission_reqs_url"
                                                control={control}
                                                rules={publishableValidationSchema.data_submission_reqs_url}
                                                defaultValue=""
                                                render={({field}) => (
                                                    <TextField fullWidth
                                                            label=""
                                                            className="form-field"
                                                            {...field} />
                                                )} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Is your repository listed on fairsharing.org?</label>
                                    <div className="form-error" role="alert">{errors.on_fairsharing?.message}</div>
                                    <br />
                                    <Controller
                                        name="on_fairsharing"
                                        control={control}
                                        rules={publishableValidationSchema.on_fairsharing}
                                        defaultValue="false"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                            </RadioGroup>
                                        )} />
                                </div>

                                {shouldShowField('on_fairsharing') && (
                                    <div className="form-group">
                                        <label>Provide the URL link to your repository on fairsharing.org. (Must start with http:// or https://)</label>
                                        <div className="form-error" role="alert">{errors.fairsharing_url?.message}</div>
                                        <br />
                                        <Controller
                                            name="fairsharing_url"
                                            control={control}
                                            rules={publishableValidationSchema.fairsharing_url}
                                            defaultValue=""
                                            render={({field}) => (
                                                <TextField fullWidth
                                                        label=""
                                                        className="form-field"
                                                        {...field} />
                                            )} />
                                    </div>
                                )}
                            </div>
                        </Grid>

                        <Grid xs={12} xl={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Select the data format(s) that this repository accepts.
                                        <span className='red-icon'>*</span>
                                    </label>
                                    <div className="form-error" role="alert">{errors.data_formats?.message}</div>
                                    <Controller
                                        name="data_formats"
                                        control={control}
                                        rules={publishableValidationSchema.data_formats}
                                        defaultValue={[]}
                                        render={({field: {onChange, value}}) => (
                                            <ManagementFacetSelector
                                                className="form-field"
                                                onSelect={(e, data) => { console.log('data'); console.log(data); onChange(data) }}
                                                defaultValue={repository['data_formats']}
                                                {...register('data_formats')}
                                                value={value}
                                                id={'data_formats'}
                                                facet='data_formats_unfiltered' />
                                        )}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>If the repository accepts additional format, enter those here. Separate multiple
                                        entries with a comma i.e. "imaging, medical records"</label>
                                    <div className="form-error" role="alert">{errors.new_data_formats?.message}</div>
                                    <br />
                                    <Controller
                                        name="new_data_formats"
                                        control={control}
                                        rules={publishableValidationSchema.new_data_formats}
                                        defaultValue=""
                                        render={({field}) => (
                                            <TextField fullWidth
                                                    label=""
                                                    className="form-field"
                                                    {...field} />
                                        )} />
                                </div>
                            </div>
                        </Grid>

                        <Grid xs={12} xl={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Select the data type(s) that this repository accepts.
                                        <span className='red-icon'>*</span>
                                    </label>
                                    <div className="form-error" role="alert">{errors.data_types?.message}</div>
                                        <Controller
                                            name="data_types"
                                            control={control}
                                            rules={publishableValidationSchema.data_types}
                                            defaultValue={[]}
                                            render={({field: {onChange, value}}) => {
                                                console.log('🎨 data_types render - value:', value);
                                                return (
                                                    <ManagementFacetSelector
                                                        className="form-field"
                                                        onSelect={(e, data) => {
                                                            console.log('data_types onSelect:', data);
                                                            onChange(data);
                                                        }}
                                                        value={value || []}
                                                        id={'data_types'}
                                                        facet='data_types'
                                                    />
                                                );
                                            }}
                                        />
                                </div>

                                <div className="form-group">
                                    <label>If the repository accepts other data types, enter those here. Separate multiple
                                        entries with a comma i.e. "imaging, medical records"</label>
                                    <div className="form-error" role="alert">{errors.new_data_types?.message}</div>
                                    <br />
                                    <Controller
                                        name="new_data_types"
                                        control={control}
                                        rules={publishableValidationSchema.new_data_types}
                                        defaultValue=""
                                        render={({field}) => (
                                            <TextField fullWidth
                                                    label=""
                                                    className="form-field"
                                                    {...field} />
                                        )} />
                                </div>
                            </div>
                        </Grid>

                        <Grid xs={12} xl={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Select the organism(s) that this repository accepts data on.
                                        <span className='red-icon'>*</span>
                                    </label>
                                    <div className="form-error" role="alert">{errors.organisms?.message}</div>
                                    <Controller
                                        name="organisms"
                                        control={control}
                                        rules={publishableValidationSchema.organisms}
                                        defaultValue={[]}
                                        render={({field: {onChange, value}}) => (
                                            <ManagementFacetSelector
                                                className="form-field"
                                                onSelect={(e, data) => { console.log('data'); console.log(data); onChange(data) }}
                                                defaultValue={repository['organisms']}
                                                {...register('organisms')}
                                                value={value}
                                                id={'organisms'}
                                                facet='organisms' />
                                            )} />
                                </div>

                                <div className="form-group">
                                    <label>If the repository accepts other organisms, enter those here. Separate multiple
                                        entries with a comma i.e. "imaging, medical records"</label>
                                    <div className="form-error" role="alert">{errors.new_organisms?.message}</div>
                                    <br />
                                    <Controller
                                        name="new_organisms"
                                        control={control}
                                        rules={publishableValidationSchema.new_organisms}
                                        defaultValue=""
                                        render={({field}) => (
                                            <TextField fullWidth
                                                    label=""
                                                    className="form-field"
                                                    {...field} />
                                        )} />
                                </div>
                            </div>
                        </Grid>

                        <Grid xs={12} xl={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>
                                        Select the research area(s) that this repository accepts data from.
                                        <span className='red-icon'>*</span>
                                    </label>
                                    <div className="form-error" role="alert">{errors.research_areas?.message}</div>
                                    <Controller
                                        name="research_areas"
                                        control={control}
                                        rules={publishableValidationSchema.research_areas}
                                        defaultValue={[]}
                                        render={({field: {onChange, value}}) => (
                                            <ManagementFacetSelector
                                                className="form-field"
                                                onSelect={(e, data) => { console.log('data'); console.log(data); onChange(data) }}
                                                defaultValue={repository['research_areas']}
                                                {...register('research_areas')}
                                                value={value}
                                                id={'research_areas'}
                                                facet='research_areas' />
                                            )} />
                                </div>

                                <div className="form-group">
                                    <label>If the repository accepts other research areas, enter those here. Separate
                                        multiple entries with a comma i.e. "imaging, medical records"</label>
                                    <div className="form-error" role="alert">{errors.new_research_areas?.message}</div>
                                    <br />
                                    <Controller
                                        name="new_research_areas"
                                        control={control}
                                        rules={publishableValidationSchema.new_research_areas}
                                        defaultValue=""
                                        render={({field}) => (
                                            <TextField fullWidth
                                                    label=""
                                                    className="form-field"
                                                    {...field} />
                                        )} />
                                </div>
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Is your repository a generalist repository?</label>
                                    <br />
                                    <Controller
                                        name="generalist"
                                        control={control}
                                        rules={publishableValidationSchema.generalist}
                                        defaultValue="false"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Generalist" />
                                                <FormControlLabel value="false" control={<Radio />} label="Domain-Specific" />
                                            </RadioGroup>
                                        )} />
                                </div>
                            </div>
                        </Grid>

                        <Grid xs={6}>
                            <div className="form-collection">
                                <div className="form-group">
                                    <label>Does your repository have a private sharing option?</label>
                                    <div className="form-error" role="alert">{errors.private_sharing?.message}</div>
                                    <br />
                                    <Controller
                                        name="private_sharing"
                                        control={control}
                                        rules={publishableValidationSchema.private_sharing}
                                        defaultValue="null"
                                        render={({field}) => (
                                            <RadioGroup row defaultValue="Unknown" className="form-field" {...field}>
                                                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="false" control={<Radio />} label="No" />
                                                <FormControlLabel value="null" control={<Radio />} label="Unclear" />
                                            </RadioGroup>
                                        )} />
                                </div>
                            </div>
                        </Grid>
                    </Grid>

                    <br/>
                    {isEditMode &&
                        <div className="form-collection">
                            <h3>Change Log (Change log data will not be displayed on the public site.)</h3>
                            <div className="form-group">
                                <h4>Previous Edits:</h4>
                                <div className="change-log">{repository["change_log"]}</div>
                            </div>

                            <div className="form-group">
                                <label>Please enter a detailed explanation of the changes you are making in this edit, as well as a justification/reason for the changes.<span className='red-icon'>*</span></label>
                                <div className="form-error" role="alert">{errors.change_log_comment?.message}</div>
                                <br/>
                                <Controller
                                    name="change_log_comment"
                                    control={control}
                                    rules={publishableValidationSchema.change_log_comment}
                                    defaultValue=""
                                    render={({field}) => (
                                        <TextField fullWidth
                                            multiline
                                            minRows={3}
                                            label="Change Notes"
                                            className="form-field"
                                            {...field} />
                                    )} />
                            </div>
                        </div>
                    }

                    <br />
                    <h3>Registering contact (contact data will not be displayed on the public site)</h3>

                    <div className="form-group">
                        <label>Name of person registering repository</label>
                        <div className="form-error" role="alert">{errors.registering_name?.message}</div>
                        <br />
                        <Controller
                            name="registering_name"
                            control={control}
                            rules={publishableValidationSchema.registering_name}
                            defaultValue=""
                            render={({field}) => (
                                <TextField
                                    label="Name"
                                    className="form-field"
                                    {...field} />
                            )} />
                    </div>

                    <div className="form-group">
                        <label>Phone number of person registering repository</label>
                        <div className="form-error" role="alert">{errors.registering_phone?.message}</div>
                        <br />
                        <Controller
                            name="registering_phone"
                            control={control}
                            defaultValue=""
                            render={({field}) => (
                                <TextField
                                    label="Phone number (xxx)xxx-xxxx"
                                    className="form-field"
                                    {...field} />
                            )}
                            rules={publishableValidationSchema.registering_phone} />
                    </div>

                    <div className="form-group">
                        <label>E-mail of person registering</label>
                        <div className="form-error" role="alert">{errors.registering_email?.message}</div>
                        <br />
                        <Controller
                            name="registering_email"
                            control={control}
                            defaultValue=""
                            render={({field}) => (
                                <TextField
                                    label="E-mail"
                                    className="form-field"
                                    {...field} />
                            )}
                            rules={publishableValidationSchema.registering_email} />
                    </div>

                    <div className="form-group">
                        <label>Status</label>
                        <br/>
                        {publish_status(repository.status) === 0 &&
                        <Chip className='repository-chip'
                              style={{backgroundColor: 'rgba(80, 148, 124, 1)', color: 'white'}}
                              label='Published'/>
                        }
                        {publish_status(repository.status) === 1 &&
                        <Chip className='repository-chip'
                              style={{ backgroundColor: 'rgba(194, 142, 34, 1)', color: 'white' }}
                              label='In Review' />
                        }
                        {publish_status(repository.status) === 2 &&
                        <Chip className='repository-chip'
                              style={{ backgroundColor: 'rgba(194, 142, 34, 1)', color: 'white' }}
                              label='Ready for Publish' />
                        }
                        {publish_status(repository.status) === 3 &&
                        <Chip className='repository-chip'
                              style={{ backgroundColor: '#737373', color: 'white' }}
                              label='Draft' />
                        }
                    </div>

                    <br />
                    <br />

                    <Dialog onClose={handleClose} open={open}>
                        <DialogTitle>Confirm Publish Edits</DialogTitle>
                        <DialogContent>
                            <div>
                                Taking this action will add the following new options to the filters: <br/>
                                <div style={{ marginBottom: '10px' }}>
                                    <b>Organisms: </b>
                                    {submittedData.new_organisms}
                                    <br />
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <b>Research Areas: </b>
                                    {submittedData.new_research_areas}
                                    <br />
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <b>Data Types: </b>
                                    {submittedData.new_data_types}
                                    <br />
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <b>Data Formats: </b>
                                    {submittedData.new_data_formats}
                                    <br />
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <b>Affiliations: </b>
                                    {submittedData.new_affiliations}
                                    <br />
                                </div>
                            </div>

                            <DialogContentText id="alert-dialog-description">
                                Click 'Yes' to save changes and add these new filters.
                            </DialogContentText>

                        </DialogContent>
                        <DialogActions>
                            <Button id='accept_publish_no_button' onClick={handleClose} >No</Button>
                            <Button id='accept_publish_yes_button' onClick={handlePublishEdits} autoFocus>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <div>
                        {isEditMode && publish_status(repository.status) === 0
                            ? <Button type="submit" variant="contained" color="primary">
                                Submit and Publish Edits
                            </Button>
                            : <Button type="submit" variant="contained" color="primary">
                                Submit and Preview
                            </Button>
                        }
                    </div>

                    <div className="form-page-error" role="alert">
                        {(errors && Object.keys(errors).length > 0) &&
                            <span>Please complete all required fields</span>
                        } 
                    </div>
                </form>
            </Box>
        </React.Fragment>);
    }
}

const publish_status = (value) => {
    switch (value) {
        case 'Published':
            return 0;
        case 'In Review':
            return 1;
        case 'Ready for Publish':
            return 2;
        default:
            return 3;
    }
}

export default RepositoryAddEditPage;